export default __webpack_public_path__ + "static/media/project2.f4c860bc.jpg";